import React from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import UploadPage from '../pages/Upload/index';
import CallbackPage from '../pages/Callback/index';
import AuthGate from '../components/AuthGate';
import { ChatViewerWrapper } from '../components/AuthGate/ChatViewerWrapper';

const router = createBrowserRouter([
	{
		path: '/',
		element: (
			<AuthGate redirPage="/">
				<UploadPage />
			</AuthGate>
		),
	},
	{
		path: '/callback',
		element: <CallbackPage />,
	},
	// kept to support old dashboards - this can be removed if cellebrite-xml is deprecated or 180+ days have passed (roughly Jan '27)
	{
		path: '/view/:container/:fileName',
		element: <ChatViewerWrapper baseRoute="/view" />,
	},
	{
		path: '/view/:pipelineType/:container/:fileName',
		element: <ChatViewerWrapper baseRoute="/view" />,
	},
]);

const App: React.FC = () => {
	return <RouterProvider router={router}></RouterProvider>;
};

export default App;
